var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 7a.853.853 0 0 0-.852-.852H3.463L7.847 1.62a.85.85 0 0 0-.03-1.206.852.852 0 0 0-1.206.032L.86 6.413a.853.853 0 0 0 0 1.174l5.753 5.966a.853.853 0 0 0 1.236-1.174L3.462 7.852h15.061c.47 0 .852-.382.852-.852Z",
    fill: "#282828"
  })));
};

export default SvgArrowLeft;